import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DsButtonModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-equal-customer-sync',
  imports: [DsButtonModule],
  template: `
    <div class="container-fluid">
      <div class="row">
        <span class="text-regular col-auto">{{ i18n('nscSync.customerEqualitySync.description') }}</span>
      </div>
      <div class="row">
        <span class="text-regular col-auto">{{ i18n('nscSync.customerEqualitySync.continueQuestion') }}</span>
      </div>

      <!-- Navigation buttons -->
      <div class="row control-button-row justify-content-end">
        <div class="button col-auto">
          <ds-button id="back-button" variant="outline" [disabled]="isLoading()" (click)="back.emit()">{{
            i18n('button.back')
          }}</ds-button>
        </div>
        <div class="button col-auto">
          <ds-button id="sync-button" ds-loading (click)="sync.emit()" [isLoading]="isLoading()">
            {{ i18n('nscSync.customerComparison.button.sync') }}
          </ds-button>
        </div>
      </div>
    </div>
  `,
  styleUrl: './equal-customer-sync.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EqualCustomerSyncComponent {
  protected readonly i18n = useI18n();

  readonly isLoading = input(false);

  readonly back = output();
  readonly sync = output();
}
